/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { href } from "../App/href";
import { CartProvider } from "../cart/cart";
import { useInvokeClient, type Product } from "../client";
import { FailureView } from "../FailureView/FailureView";
import { LoadingView } from "../LoadingView/LoadingView";
import { Page, ViewContent } from "../oss/Layout/Layout";
import { LoginNeededBanner } from "./ActionBanner";
import { ProductCard } from "./ProductCard.tsx";
import { ShoppingCartPill } from "./ShoppingCart.tsx";
import { useScrollToFragment } from "./useScrollToFragment";

function ShopPageSuccess(props: {
  products: Product[];
  title: string;
  backHref: string;
}) {
  useScrollToFragment();
  const { products, ...rest } = props;

  return (
    <CartProvider products={products}>
      <Page {...rest}>
        <LoginNeededBanner
          backTo={href("~/shop", { search: { note: "loginNeeded" } })}
          redirectTo={href("~/shop")}
        />

        <ViewContent>
          {products.map((product) => {
            return <ProductCard key={product.id} product={product} />;
          })}
        </ViewContent>

        <ShoppingCartPill />
      </Page>
    </CartProvider>
  );
}

export function ShopPage() {
  const [result] = useInvokeClient("getShopProducts", ["greathelm", "usd"]);
  const pageProps = { title: "Shop", backHref: "~/" };

  if (result.isPending) {
    return (
      <Page {...pageProps}>
        <LoadingView />
      </Page>
    );
  }

  if (result.isFailure) {
    return (
      <Page {...pageProps}>
        <FailureView failure={result.failure} />
      </Page>
    );
  }

  return <ShopPageSuccess {...pageProps} products={result.value.items} />;
}
